import { FileDownload, FileInfo } from '../models';
import { getFileExtension } from './file-name-helper';

export const fileInfoToFileDownloadModel = (fileInfo: FileInfo): FileDownload => ({
    name: fileInfo.name,
    extension: getFileExtension(fileInfo.name, true),
    id: fileInfo.id,
    inProgress: false,
    size: fileInfo.size,
    scanType: fileInfo.fileType,
});
